export const GEO_REQUIRED_MESSAGE =
  "Location access is mandatory to apply for a loan. Please allow location permission and try again.";

/**
 * Required geolocation lookup for loan application.
 * Resolves { ok: true, lat, long } or { ok: false, error }.
 */
export function getApplicantGeolocation(timeoutMs = 12000) {
  return new Promise((resolve) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) {
      resolve({ ok: false, error: GEO_REQUIRED_MESSAGE });
      return;
    }

    const options = {
      enableHighAccuracy: true,
      timeout: timeoutMs,
      maximumAge: 0,
    };

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position?.coords?.latitude;
        const long = position?.coords?.longitude;
        if (lat == null || long == null || Number.isNaN(Number(lat)) || Number.isNaN(Number(long))) {
          resolve({ ok: false, error: GEO_REQUIRED_MESSAGE });
          return;
        }
        resolve({ ok: true, lat: String(lat), long: String(long) });
      },
      () => resolve({ ok: false, error: GEO_REQUIRED_MESSAGE }),
      options
    );
  });
}
